
function WoocommerceFilterShop(){

    $('.filter-product-cat').on('change', function(){
        window.location = $(this).val();
    });

}